import { Observable, BehaviorSubject } from "rxjs";
import {
  Component,
  OnInit,
  ViewChild,
  HostListener,
  ChangeDetectorRef,
  Inject,
  EventEmitter,
  Output,
  Input,
} from "@angular/core";

import { PoolService } from "src/app/services/pool.service";
import { AuthService } from "src/app/services/auth.service";
import { ParamService } from "src/app/services/param.service";
import { FormControl } from "@angular/forms";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { SelectionModel } from "@angular/cdk/collections";
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { formatDate } from "@angular/common";
// import pdfmake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// pdfmake.vfs = pdfFonts.pdfMake.vfs;
// import * as _moment from "moment";
// const moment = _moment;
import moment from "moment";

export interface Language {
  label: string;
  labelName: string;
}

export interface LanguageMap {
  [key: string]: Language;
}

interface RptElement {
  id: number;
  employeeCode: string;
  employeeName: string;
  approveTypeId: number;
  startDate: Date;
  // startTime: string;
  endDate: Date;
  // endTime: string;
  duration: number;
  remoteDates: Date[]; // ⚡ Evden çalışma dağınık gün listesi
  currentApproverName: string;
  approvalStatus: string; // "Tamamlandı", "Onayda Bekliyor", "Reddedildi"
  rejectDescription: string;
}

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "LL",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-approvaltrack",
  templateUrl: "./approvaltrack.component.html",
  styleUrls: ["./approvaltrack.component.scss"],
  providers: [
    // {provide: DateAdapter, useClass: OutofofficeComponent},
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true } },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ApprovalTrackComponent implements OnInit {
  form!: FormGroup;
  language: any = [];
  languageMap: LanguageMap = {};
  usrlanguages: any = [];
  selectedFlow: any;
  prmfmYemek = false;
  prmfmServis = false;
  isMobile: boolean = false;
  employees: any = [];
  user: string = "";
  userType: string = "";
  rptData: any = [];
  rptDataSource: any;
  rptDisplayedColumns: any;
  rptSelection: any;
  @ViewChild("rptPaginator", { static: true }) rptPaginator!: MatPaginator;
  @ViewChild("rptSorter", { static: true }) rptSort!: MatSort;
  pageIndex: number = 0;
  outofoffice: { [key: number]: { id: number; value: string; color: string } } =
    {};

  constructor(
    private cdr: ChangeDetectorRef,
    private _formBuilder: FormBuilder,
    private AuthService: AuthService,
    private PoolService: PoolService,
    private ParamService: ParamService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private adapter: DateAdapter<any>,
  ) {}

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.checkDeviceType();
  }

  // getUserLanguage() {
  //   this.ParamService.getLanguage().subscribe((res) => {
  //     this.usrlanguages = res;
  //     this.getLanguage(this.usrlanguages[0].id);
  //   });
  // }

  ngOnInit() {
    this.form = this._formBuilder.group({
      employee: ["", Validators.required],
      flow: ["", Validators.required],
      startDate: [],
      endDate: [],
    });

    this.AuthService.getUserName.subscribe(
      (user) => (this.user = user ? user : ""),
    );
    this.AuthService.getUserType.subscribe(
      (userType) => (this.userType = userType ? userType : ""),
    );
    this.getAuth(this.user, this.userType);
    this.getLanguage(JSON.parse(localStorage.getItem("language")!).id);
    this.turkishCulture();
    this.form.patchValue({ flow: "Günlük İzin" });
    this.getEmployees();
    this.checkDeviceType();

    // this.resetReport();
  }

  public exportPdf() {
    let pdf = [];
    pdf.push([
      { text: "SicilNo", bold: true },
      { text: "Adı", bold: true },
      { text: "Türü", bold: true },
      { text: "Neden", bold: true },
      { text: "Açıklama", bold: true },
      { text: "BaşTarih", bold: true },
      { text: "BitTarih", bold: true },
      { text: "Süre", bold: true },
      { text: "Amir1", bold: true },
      { text: "Amir2", bold: true },
      { text: "Amir3", bold: true },
      { text: "Amir4", bold: true },
      { text: "Amir5", bold: true },
      { text: "Durum", bold: true },
      { text: "İşlemZaman", bold: true },
    ]);
    this.rptDataSource.data.forEach((element: any) => {
      var start = moment(element["basTarih"]);
      pdf.push([
        element["prSicil"],
        element["adi"],
        element["izinTuru"],
        element["neden"],
        element["acik"],
        formatDate(element["basTarih"], "dd-MM-yyyy", "en-US"),
        formatDate(element["bitTarih"], "dd-MM-yyyy", "en-US"),
        element["sure"],
        element["onay1kl"],
        element["onay2kl"],
        element["onay3kl"],
        element["onay4kl"],
        element["onay5kl"],
        element["durum"],
        formatDate(element["islemZaman"], "dd-MM-yyyy", "en-US"),
      ]);
    });

    var dd = {
      content: [
        {
          // layout: 'lightHorizontalLines', // optional
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            // widths: [ '*', 'auto', 100, '*' ],
            headerRows: 1,
            widths: [
              "*",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
            ],
            body: pdf,
          },
        },
      ],

      defaultStyle: {
        fontSize: 7,
      },
    };

    // const documentDefinition = { content: "TalepListe" };
    // pdfmake.createPdf(dd).download();
  }

  getLanguage(lng: any) {
    let data;
    this.ParamService.getLanguageInfo().subscribe((res: any) => {
      Object.keys(res).forEach((key) => {
        let data = { label: res[key].label, labelName: res[key].labelName };
        this.language.push(data);
      });

      this.language.forEach((s: Language) => {
        this.languageMap[s.label] = s;
      });
    });
  }

  turkishCulture() {
    this.adapter.setLocale("tr");
  }

  closeDialog() {}

  applyFilter(filterValue: string) {
    this.rptDataSource.filter = filterValue.trim().toLocaleUpperCase();
  }

  getAuth(user: any, type: any) {
    this.outofoffice = {}; // Her istek öncesi sıfırlamak için

    this.AuthService.getPoolAuth().subscribe(
      (res: any) => {
        if (res["gunluk"])
          this.outofoffice[1] = {
            id: 1,
            value: "Günlük İzin",
            color: "#64748b",
          };
        if (res["saatlik"])
          this.outofoffice[2] = {
            id: 2,
            value: "Saatlik İzin",
            color: "#0d9488",
          };
        if (res["mesai"])
          this.outofoffice[3] = {
            id: 3,
            value: "Fazla Mesai",
            color: "#ef4444",
          };
        if (res["hareket"])
          this.outofoffice[5] = {
            id: 5,
            value: "Hareket",
            color: "#7c3aed",
          };
        if (res["evden"])
          this.outofoffice[10] = {
            id: 10,
            value: "Evden Çalışma",
            color: "#1e40af",
          };
      },
      (err) => {
        console.log(err);
      },
    );
  }

  getEmployees() {
    this.PoolService.getPoolUsers(this.user, this.userType).subscribe(
      (res: any) => {
        this.employees = res;
      },
    );
  }

  onFlowTypeChange(event: any): void {
    // this.form.patchValue({
    //   startdate: null,
    //   enddate: null,
    // });
    this.selectedFlow = event.value;
    const selectedFlow = event.value; // Örn: "Evden Çalışma" veya ID bazlı 10
    if (selectedFlow === "Evden Çalışma" || selectedFlow === 10) {
      const now = new Date();
      const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.form.patchValue({
        startDate: firstDayOfMonth,
        endDate: lastDayOfMonth,
      });
    }
  }

  executeReport() {
    if (this.form.valid) {
      let config = new MatSnackBarConfig();
      config.panelClass = ["message-position"];
      this.snackBar.open("İşlem yapılıyor. Lütfen Bekleyiniz...", "", config);

      const employeeId = this.form.value.employee;
      const flow = this.form.value.flow;
      const startDate = formatDate(
        this.form.value.startDate,
        "yyyy-MM-ddT00:00:00",
        "en-US",
      );
      const endDate = formatDate(
        this.form.value.endDate,
        "yyyy-MM-ddT00:00:00",
        "en-US",
      );

      this.PoolService.dailySummary(employeeId, startDate, endDate).subscribe({
        next: (res: any) => {
          console.log(res);
        },
      });

      this.PoolService.fetchReport(
        employeeId,
        startDate,
        endDate,
        flow,
      ).subscribe({
        next: (res: RptElement[]) => {
          if (res) {
            this.rptData = res;
            if (this.isMobile) {
              if (this.selectedFlow == 1)
                this.rptDisplayedColumns = [
                  "mobileCardHeader",
                  "employeeName",
                  "startDate",
                  "endDate",
                  "duration",
                  "workStartDate",
                  "currentApproverName",
                  "approvalStatus",
                  "actions",
                ];
              else
                this.rptDisplayedColumns = [
                  "mobileCardHeader",
                  "employeeName",
                  "startDate",
                  "endDate",
                  "duration",
                  "currentApproverName",
                  "approvalStatus",
                  "actions",
                ];
            } else {
              this.rptDisplayedColumns = [
                "id",
                "approveTypeId",
                "employeeCode",
                "employeeName",
                "startDate",
                "endDate",
                "duration",
                "currentApproverName",
                "approvalStatus",
              ];
            }

            // 3. 📊 DATASOURCE BAĞLANTISI: Tablo veri kaynağını canlandırıyoruz
            this.rptDataSource = new MatTableDataSource<RptElement>(
              this.rptData,
            );

            // 4. EMNİYET KİLİDİ: Angular Material'ın DOM'a basılmasını (Render cycle) kaçırmamak için
            // paginator ve sort atamalarını setTimeout ile mikro saniyelik geciktirerek güvene alıyoruz.
            setTimeout(() => {
              this.rptDataSource.paginator = this.rptPaginator;
              this.rptDataSource.sort = this.rptSort;
              this.cdr.detectChanges();
            });

            // 5. SEÇİM MODELİ: Tablodaki checkbox seçim yapısını sıfırlayıp yeniden başlatıyoruz
            this.rptSelection = new SelectionModel<RptElement>(true, []);

            // console.log(
            //   "Talep takip raporu başarıyla yüklendi. Satır sayısı:",
            //   this.rptData.length,
            // );

            this.snackBar.dismiss();
          }
        },
        error: (err) => {
          console.error("Rapor çekilirken backend tarafında hata oluştu:", err);
          // this.toast.error(
          //   this.languageMap["INVALID_DATA_SUBMITTED"]?.labelName ||
          //     "Rapor yüklenemedi.",
          // );
        },
      });
    }
  }

  getParameters() {
    this.ParamService.getParameters().subscribe(
      (res: any) => {
        Object.keys(res).forEach((key) => {
          this.prmfmYemek = res[key].fmYemek;
          this.prmfmServis = res[key].fmServis;
        });
      },
      (err) => {
        console.log(err);
      },
    );
  }

  private checkDeviceType(): void {
    // ⚡ MOBİL CİHAZ EMNİYETİ: Eğer pencere genişliği 0 veya tanımsız gelirse
    // mobil cihazları korumak için varsayılan olarak mobil kabul et (Fallback)
    const width =
      window.innerWidth || document.documentElement.clientWidth || 360;
    this.isMobile = width <= 768;

    if (this.isMobile) {
      this.rptDisplayedColumns = [
        "employeeName",
        "startDate",
        "approvalStatus",
        "actions",
      ];
    } else {
      this.rptDisplayedColumns = [
        "id",
        "employeeCode",
        "employeeName",
        "startDate",
        "endDate",
        "duration",
        "currentApproverName",
        "approvalStatus",
      ];
    }

    // ⚡ KRİTİK TETİKLEYİCİ: Angular'ın render döngüsünü zorluyoruz
    this.cdr.detectChanges();
  }
}
